import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HomepageNewsletterMobile } from 'components/eventView/addons/homepageNewsletter/HomepageNewsletterMobile';
import { EventEntityItem } from 'components/eventView/pages/eventData';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useAnalytics } from 'libs/utils/site/analytics';
import { EVFormPC } from 'pages/EventViewPage/EventViewPagePC/EVFormPc';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components';

interface Props {
    className?: string;
}

export const BaterCompetitionLink = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const isWide = useIsWide();
    const [isForm, setIsForm] = useState(false);
    const analytics = useAnalytics();

    const content = (
        <>
            <S_Head $src="https://dvtqxks0zalev.cloudfront.net/07d3e443-4653-4ec5-8be9-1e15bae8fdad.png" />
            <S_Body>
                <S_Left>
                    <S_T>Delta i vår konkurranse!</S_T>
                    <S_B>Vinn en Yamaha SuperJet Vannscooter</S_B>
                </S_Left>
                <S_Icon>
                    <S_FontAwesomeIcon icon={['far', 'trophy-star']} />
                </S_Icon>
            </S_Body>
        </>
    );

    const form = ctxEventView.forms[0];
    console.log('Form', form, ctxEventView.forms);

    if (isWide) {
        return (
            <>
                <S_CompetitionLink
                    className={props.className}
                    onClick={() => {
                        //redirect in new window
                        analytics.track('event_ui.external_link', {
                            source: 'bater_competition'
                        });

                        const mobilePath = `https://www.lydenavnorge.no/p4/underholdning/konkurranser/vinn-en-yamaha-superjet-vannscooter/artikkel/943473/`;
                        window.open(mobilePath, '_blank');
                        // setIsForm(true);

                        // searchParams.delete('detailId');
                        // searchParams.delete('markerId');
                        // searchParams.delete('detailEntityType');
                        // searchParams.delete('detailEntityId');
                        // setSearchParams(searchParams);
                    }}
                >
                    {content}
                </S_CompetitionLink>
                {isForm && (
                    <EVFormPC
                        form={form}
                        onClose={() => {
                            setIsForm(false);
                        }}
                        title="Delta i vår konkurranse!"
                    />
                )}
            </>
        );
    } else {
        return (
            <S_CompetitionLink
                className={props.className}
                onClick={() => {
                    // const mobilePath = `/event/${ctxEventView.eventPath}/form/da8a4c0a-3083-4b7b-a329-d0658fb5b813`;
                    // navigate(mobilePath);
                    analytics.track('event_ui.external_link', {
                        source: 'bater_competition'
                    });
                    const mobilePath = `https://www.lydenavnorge.no/p4/underholdning/konkurranser/vinn-en-yamaha-superjet-vannscooter/artikkel/943473/`;
                    window.open(mobilePath, '_blank');
                }}
            >
                {content}
            </S_CompetitionLink>
        );
    }
};

const S_CompetitionLink = styled.div`
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    border-radius: 27px;
    overflow: hidden;
`;

const S_Head = styled.div<{ $src: string }>`
    background-image: url(${(props) => props.$src});
    background-size: cover;
    background-position: center;
    height: 90px;
`;

const S_Body = styled.div`
    display: flex;
    padding: 20px;
    background-color: #fcfc72;
    align-items: center;
    background-image: url('https://dvtqxks0zalev.cloudfront.net/d4656d5a-df80-4e87-8c9e-c4b6380f9bc0.jpeg');
    background-size: cover;
    background-position: center;
    justify-content: space-between;
`;

const S_Left = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_T = styled.div`
    color: #041321;
    font-family: 'InterBold';
    font-size: 15px;
`;

const S_B = styled.div`
    margin-top: 10px;
    font-family: InterMedium;
    font-size: 14px;
    color: #041321;
`;

const S_Icon = styled.div`
    background-color: #37416b;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
`;

const S_FontAwesomeIcon = styled(FontAwesomeIcon)`
    color: white;
    font-size: 20px;
`;

export const BaterFooter = () => {
    const ctxEventView = useContext(CtxEventView);

    const analytics = useAnalytics();
    const navigate = useNavigate();

    const entityState = ctxEventView.entityStates['50d99d94-316c-4e84-a0be-e300da76bae1'];

    const stories = entityState?.all;

    function onClick(story: EventEntityItem) {
        analytics.track('event_ui.detail.open_clicked', {
            type: 'footer',
            storyId: story.storyId,
            title: story.storyHeader?.title ?? ''
        });

        const url = '/event/bater2024/detail/' + story.storyId;
        navigate(url);
    }

    return (
        <S_Partners>
            <S_Title>Partnere</S_Title>
            <S_Logos>
                {stories?.map((row) => (
                    <S_LogoLink key={row.storyId} onClick={() => onClick(row)}>
                        <S_Logo src={row.imageUrl} />
                    </S_LogoLink>
                ))}
            </S_Logos>
        </S_Partners>
    );
};

const S_Partners = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_Logos = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin: 20px 0 0 0;
    border-radius: 27px;
    background-color: #eaf0f5;
    padding: 15px;
    align-items: center;
`;

const S_LogoLink = styled.div`
    cursor: pointer;
`;

const S_Logo = styled.img`
    width: 100px;
    height: auto;
`;

const S_Title = styled.div`
    font-size: 15px;
    margin-top: 25px;
    text-align: center;
    font-family: 'InterMedium';
    color: #fff;
`;

export const BaterPCHeader = () => {
    return (
        <S_BaterPCHeader>
            <S_BaterCompetitionLink />
            <S_HomepageNewsletterMobile />
        </S_BaterPCHeader>
    );
};

const S_BaterPCHeader = styled.div`
    margin: 20px 0;
    display: flex;
    gap: 20px;
    align-items: flex-start;
`;

const S_BaterCompetitionLink = styled(BaterCompetitionLink)`
    width: 400px;
    margin: 0;
    cursor: pointer;
`;

const S_HomepageNewsletterMobile = styled(HomepageNewsletterMobile)`
    width: 400px;
`;
